import { palette } from '@livable/saas-react-components';
const MuiAccordionSummary = {
  styleOverrides: {
    root: {
      padding: '0',
      minHeight: 'initial',
      flexDirection: 'row-reverse',
      '&.Mui-expanded': {
        minHeight: 'initial'
      },
      '&.Mui-focusVisible': {
        backgroundColor: 'transparent'
      }
    },
    content: {
      margin: '0',
      '&.Mui-expanded': {
        margin: '0'
      }
    },
    expandIconWrapper: {
      marginRight: '10px',
      '&.Mui-expanded': {
        transform: 'rotate(90deg)'
      },
      '& path': {
        fill: palette.primary.main
      }
    }
  }
};
export default MuiAccordionSummary;